'use client';

import { createContext, useContext } from 'react';

export const SaveCompletionContext = createContext<(() => void) | undefined>(undefined);
export function useSaveCompletion() {
  return useContext(SaveCompletionContext);
}
